import { render, staticRenderFns } from "./Howto.vue?vue&type=template&id=3a7988eb&scoped=true&"
import script from "./Howto.vue?vue&type=script&lang=js&"
export * from "./Howto.vue?vue&type=script&lang=js&"
import style0 from "./Howto.vue?vue&type=style&index=0&id=3a7988eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7988eb",
  null
  
)

export default component.exports